interface CherryLogoProps {
  size?: number;
  className?: string;
}

export function CherryLogo({ size = 24, className }: CherryLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M16 4C14 9 10 11 9 15"
        stroke="var(--color-success)"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M16 4C18 9 22 11 23 15"
        stroke="var(--color-success)"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="10" cy="20" r="6.5" fill="white" opacity="0.95" />
      <circle cx="10" cy="20" r="5.5" fill="var(--color-cherry-500)" />
      <ellipse cx="8.5" cy="18.5" rx="1.5" ry="1" fill="white" opacity="0.4" />
      <circle cx="22" cy="20" r="6.5" fill="white" opacity="0.95" />
      <circle cx="22" cy="20" r="5.5" fill="var(--color-cherry-600)" />
      <ellipse cx="20.5" cy="18.5" rx="1.5" ry="1" fill="white" opacity="0.4" />
    </svg>
  );
}
